<template>

  <b-modal
      id="form-add-indicator"
      modal-class='form form-export'
      modal-footer="hide"
      scrollable
      centered
      :size="this.mode === 'delete'? 'md' : 'lg'"
      :title="this.title"
  >

    <div class="form form__export">
      <b-overlay
          id="overlay-challenge"
          :show="showMe"
          rounded="sm"
          variant="white"
          opacity='0.8'
          blur="2px"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
      >

        <b-form v-if="mode === 'create' || mode === 'see'">
          <b-row v-if="mode !== 'see'">
            <b-col sm="12">
              <label for="input-group-4">Valeurs</label>
              <b-form-group
                  id="input-group-4"
              >
                <div class="desktop">
                  <div class="d-flex">
                    <v-select label="value" v-model='searchParentCategory' class="select" :disabled="formDisabled" :options="parentCategories" placeholder="Rechercher une catégorie parente..." @input="setParentCategory"></v-select>

                    <v-select label="value" v-model='searchCategory' class="select ml-3" :disabled="formDisabled" :options="categories" placeholder="Rechercher une catégorie ..." @input="setCategory"></v-select>
                  </div>
                  <div class="d-flex">
                    <v-select label="text" v-model='selectedCriteria' class="select mt-3" :disabled="formDisabled" :options="criterias" placeholder="Rechercher un critère ..."></v-select>

                  </div>
                </div>
                <div class="mobile">
                  <v-select label="value" v-model='searchCategory' class="select mb-3" :disabled="formDisabled" :options="categories" placeholder="Rechercher une catégorie ..." @input="setCategory"></v-select>

                  <v-select label="text" v-model='selectedCriteria' class="select" :disabled="formDisabled" :options="criterias" placeholder="Rechercher un critère ..."></v-select>

                </div>
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <label for="input-group-4">Inverser critère positif en négatif ?</label>
              <div class="inverse-value" :class="inverse ? 'inverse' : 'not-inverse'" @click="updateInverseValue()">Oui</div>
            </b-col>
          </b-row>
        </b-form>

        <div v-if="mode === 'delete'">
          Voulez-vous supprimer l'indicateur ? <br><br> Attention, la suppression est définitive.
        </div>
      </b-overlay>
    </div>

    <template v-slot:modal-footer>
      <b-button v-if="cancel" @click="closeMe()" class="btn-cancel">
        {{formContent.formBtCancel}}
      </b-button>

      <b-button
          @click="submit()"
          class="btn-challenges ml-auto"
          :class="{disabled:isLoading}"
          :disabled="isDisable()"
      >
        {{ action }}
      </b-button>
    </template>

  </b-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import ApiService from "@/services/ApiService";
import moment from "moment/moment";
import ApiAuthenticationService from "@/services/ApiAuthenticationService";

export default {
  name: "FormAddIndicator",
  components: {
  },
  data () {
    return {
      showMe: false,
      mode: null,
      formContent: null,
      form: {
        criteria: null,
      },
      categoriesData: [],
      categories: [
        {
          value: '',
          text: 'Toutes',
        }
      ],
      parentCategories: [
        {
          value: '',
          text: 'Toutes',
        }
      ],
      criterias: [],
      parametrages: null,
      action: 'Créer',
      cancel: true,
      isLoading: false,
      formShowState: true,
      formDisabled: false,
      id: null,
      title: 'Ajouter un indicateur',
      searchCategory: '',
      searchParentCategory: '',
      inverse: false,
      categoryToAdd: '',
      selectedCriteria: null,
      user: null,
    }
  },

  computed: {
    ...mapGetters([
      'getGeneral',
      'getIndicatorUpdated'
    ]),
  },
  async created() {
    this.formContent = this.getGeneral;

    await ApiService.getParametrageApi().list().then((data) => {
      this.categoriesData = data.data.categories;
      Object.keys(data.data.categories).forEach((item) => {
        this.categories.push({
          value: item,
          text: item,
          disabled: false,
        })
      })
      this.categories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

      Object.keys(data.data.parentCategories).forEach((item) => {
        this.parentCategories.push({
          value: item,
          text: item,
          disabled: false,
        })
      })
      this.parentCategories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

      this.parametrages = data.data;

      this.loadAllCriterias();
    })
  },
  methods:{
    closeMe(reload = false){
      this.cleanMe();
      this.$root.$emit('bv::hide::modal', 'form-add-indicator');

      if (reload) {
        this.$store.dispatch('setIndicatorUpdated', {
          mode: 'reload'
        });
      }
    },
    isDisable() {
      if (this.mode === 'see') {
        return false;
      }

      return this.selectedCriteria === null || this.selectedCriteria === '';
    },
    selectCategory(category) {
      this.criterias = this.getCriterias(category);
      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
    },
    selectParentCategory(category) {
      this.categories = this.getFilteredCategories(category);
      this.criterias = [];
      for (const oneCategory of this.categories) {
        this.criterias = [...this.criterias, ...this.getCriterias(oneCategory.value)];
      }

      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
    },
    setCategory() {
      if (!this.searchCategory.value?.includes(' - ')) {
        this.searchCategory.value = this.searchParentCategory.value + ' - ' + this.searchCategory.value;
      }
      if (!this.searchCategory || !this.searchCategory.value || !Object.keys(this.parametrages.categories)?.includes(this.searchCategory.value)) {
        this.criterias = this.getCriterias();
        this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
        return;
      }

      this.selectCategory(this.searchCategory.value);
    },
    setParentCategory() {
      if (!this.searchParentCategory || !this.searchParentCategory.value || !Object.keys(this.parametrages.parentCategories)?.includes(this.searchParentCategory.value)) {
        this.searchCategory = null;
        this.selectedCriteria = null;
        this.criterias = this.getCriterias();
        this.categories = this.getFilteredCategories();
        this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));
        return;
      }

      this.selectParentCategory(this.searchParentCategory.value);
    },
    getCriterias(item = null) {
      if (item === '' || item === null) {
        return this.loadAllCriterias();
      }

      let criterias = [];

      if (!item?.includes(' - ')) {
        item = this.searchParentCategory.value + ' - ' + item;
      }

      Object.values(this.parametrages.categories[item]).forEach((criteria) => {
        criterias.push({
          value: criteria,
          text: this.parametrages.criteriasWithLabel[criteria],
          disabled: false,
        })
      })

      criterias.sort((a,b) => a.text.localeCompare(b.text));

      return criterias;
    },
    getFilteredCategories(item = null) {
      if (item === '' || item === null) {
        let categories = [];
        Object.keys(this.categoriesData).forEach((item) => {
          categories.push({
            value: item,
            text: item,
            disabled: false,
          })
        })
        categories.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

        return categories;
      }

      let categories = [];

      Object.keys(this.parametrages.parentCategories[item]).forEach((category) => {
        categories.push({
          value: category,
          text: category,
          disabled: false,
        })
      })

      categories.sort((a,b) => a.text.localeCompare(b.text));

      return categories;
    },
    loadAllCriterias() {
      this.criterias = [];
      Object.values(this.parametrages.criterias).forEach((item) => {
        this.criterias.push({
          value: item,
          text: this.parametrages.criteriasWithLabel[item],
          disabled: false,
        })
      })

      this.criterias.sort((a,b) => a.text.trim().localeCompare(b.text.trim()));

      return this.criterias;
    },
    updateInverseValue() {
      this.inverse = !this.inverse;
    },
    async submit() {
      this.isLoading = true;

      if (this.mode === 'create') {
        if (!this.user.criterias) {
          this.user.criterias = [];
        }

        this.user.criterias.push(this.selectedCriteria.value + ';' + (this.inverse ? '1' : '0'));

        await ApiService.getProfilApi().patch(this.user.id, this.user).then(() => {
          ApiAuthenticationService.reloadUser().then(()=>{
            this.isLoading = false;
            this.closeMe(true);
            this.$emit('addIndicator');
          });
        });
      }
      this.isLoading = false;
      this.closeMe();
    },
    cleanMe() {
      this.form.criteria = null;
      this.formDisabled = false;
      this.formShowState = true;
      this.searchCategory = '';
      this.selectedCriteria = '';
      this.inverse = false;
    },
    moment: function (date,year) {
      return moment(date,year);
    },
  },

  watch: {
    getIndicatorUpdated() {
      if (this.getIndicatorUpdated === '') {
        return;
      }

      this.cleanMe();
      this.mode = this.getIndicatorUpdated.mode;
      this.data = this.getIndicatorUpdated.data;
      this.action = this.getIndicatorUpdated.action;
      this.cancel = this.getIndicatorUpdated.cancel;
      this.user = this.getIndicatorUpdated.user;

      if (this.mode === 'see') {
        this.title = 'Détails de l\'indicateur ';
        this.formDisabled = true;
        this.formShowState = false;
      }

      if (this.getIndicatorUpdated && this.getIndicatorUpdated.item !== undefined) {
        if (this.mode === 'delete') {
          this.id = this.getIndicatorUpdated.item.id;
          this.title = 'Supprimer un indicateur';
        }
      }

      if (this.mode === 'create') {
        this.title = 'Ajouter un indicateur de suivi';
      }
    },
  },
}
</script>

